export default "__VITE_ASSET__c65287d8__"